import { useOrganization } from "../organizations/OrganizationProvider";

export default function useOrganizationHasSignUpOverride(): boolean {
  const [organization] = useOrganization();
  return organization.signUpOverrideId !== null;
}
